/**
 * 개인 랜딩「이달의 이슈」섹션 — 카드뉴스 소스(월간 브리프 / 운영 템플릿) 및 선택값.
 */

import { normalizePersonalLandingSections } from '../features/personalLanding/normalize'

export const CARD_NEWS_SOURCE_MONTHLY_BRIEF = 'monthly_brief'
export const CARD_NEWS_SOURCE_TEMPLATE = 'template'

export const CARD_NEWS_SOURCE_OPTIONS = [
  { id: CARD_NEWS_SOURCE_MONTHLY_BRIEF, label: '월간 이슈(보험사 소식지 기반)' },
  { id: CARD_NEWS_SOURCE_TEMPLATE, label: '운영 카드뉴스 템플릿' },
]

const DEFAULT_MONTHLY_ISSUE_EXTRAS = {
  cardNewsSource: CARD_NEWS_SOURCE_MONTHLY_BRIEF,
  cardNewsTemplateId: null,
  cardNewsTemplateEmbed: null,
}

/**
 * 섹션 content에 이달의 이슈 확장 필드 기본값 병합
 */
export function mergeMonthlyIssueContent(raw) {
  const c = raw && typeof raw === 'object' ? raw : {}
  const merged = { ...DEFAULT_MONTHLY_ISSUE_EXTRAS, ...c }
  const source = merged.cardNewsSource === CARD_NEWS_SOURCE_TEMPLATE ? CARD_NEWS_SOURCE_TEMPLATE : CARD_NEWS_SOURCE_MONTHLY_BRIEF
  const rest = { ...merged }
  delete rest.monthlyBriefAuto
  delete rest.monthlyBriefYear
  delete rest.monthlyBriefMonth
  delete rest.selectedCardImageNames
  return {
    ...rest,
    cardNewsSource: source,
    cardNewsTemplateId: merged.cardNewsTemplateId != null && merged.cardNewsTemplateId !== '' ? merged.cardNewsTemplateId : null,
    cardNewsTemplateEmbed:
      merged.cardNewsTemplateEmbed && typeof merged.cardNewsTemplateEmbed === 'object'
        ? merged.cardNewsTemplateEmbed
        : null,
  }
}

/**
 * 운영 DB 템플릿 preset에서 monthly-issue에 저장된 cardNewsTemplateEmbed 복사
 * (운영자가 템플릿 저장 시 해당 섹션에 스냅샷을 넣어 둔 경우)
 */
export function extractCardNewsEmbedFromDbTemplatePreset(preset) {
  if (!preset || typeof preset !== 'object') return null
  const sections = normalizePersonalLandingSections(
    preset.landingSections || [],
    {},
    preset.landingPageStyle
  )
  const mi = sections.find((s) => s?.type === 'monthly-issue')
  const embed = mi?.content?.cardNewsTemplateEmbed
  if (!embed || typeof embed !== 'object') return null
  const images = Array.isArray(embed.images) ? embed.images.filter((it) => it?.fileId) : []
  if (!images.length) return null
  return {
    periodLabel: typeof embed.periodLabel === 'string' && embed.periodLabel.trim() ? embed.periodLabel.trim() : null,
    payload: embed.payload && typeof embed.payload === 'object' ? embed.payload : null,
    images,
  }
}

/** "2026.04" → { year, month } */
export function parseMonthlyIssuePeriodLabel(label) {
  const s = String(label || '').trim()
  const m = s.match(/^(\d{4})\.(\d{2})$/)
  if (!m) return { year: null, month: null }
  const year = Number(m[1])
  const month = Number(m[2])
  if (!Number.isFinite(year) || !Number.isFinite(month) || month < 1 || month > 12) return { year: null, month: null }
  return { year, month }
}
